import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionHotelPolicyCancelPolicy as CancelPolicy } from "./cancel-policy";

import type { HotelPolicyCategoriesAndManagerStore } from "../../../../store/categories";

type Props = {
	cancelPolicy: HotelPolicyCategoriesAndManagerStore["cancelPolicy"];
};

export const QuestionHotelPolicyCancelPolicy = ({ cancelPolicy }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper categoryStore={cancelPolicy}>
			<CancelPolicy />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionHotelPolicyCancelPolicy.displayName = "QuestionHotelPolicyCancelPolicy";
